var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-settings-page", {
    attrs: {
      title: _vm.$t("hitl.settings.agent-status.title"),
      "show-sidebar": _vm.showSidebar,
      "show-add-button": !_vm.isInitializing,
      "is-initializing": _vm.isInitializing,
    },
    on: {
      "add-button-click": function ($event) {
        return _vm.$emit("open-create-sidebar")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("agent-status-item-list", {
              attrs: {
                "status-options": _vm.statusOptions,
                "default-status-key": _vm.defaultStatusKey,
                "target-key": _vm.targetKey,
                "is-disabled": _vm.isUpdating,
              },
              on: {
                "items-order-change": function ($event) {
                  return _vm.$emit("items-order-change", $event)
                },
                "item-click": function ($event) {
                  return _vm.$emit("open-update-sidebar", $event)
                },
                "default-key-change": function ($event) {
                  return _vm.$emit("default-key-change", $event)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "sidebar",
        fn: function () {
          return [_c("agent-status-item-sidebar-container")]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }